export const LIST_STATUSDOOR = "STATUSDOOR";
export const LIST_STATUSDOOR_SUCCESS = "STATUSDOOR_SUCCESS";
export const LIST_STATUSDOOR_FAILED = "STATUSDOOR_FAILED";


